import 'moment/locale/de'
import 'daterangepicker/daterangepicker'

var daterangeOptions = {
  showDropdowns: true,
  linkedCalendars: false,
  showCustomRangeLabel: false,
  opens: "center",
  drops: "auto",
  autoUpdateInput: false,
  cancelButtonClasses: "btn-secondary",
  locale: {
    cancelLabel: 'Abbrechen/Löschen',
    applyLabel: 'Anwenden'
  }
}

var dateOptions = {
  showDropdowns: true,
  linkedCalendars: false,
  showCustomRangeLabel: false,
  singleDatePicker: true,
  opens: "center",
  drops: "auto",
  autoUpdateInput: false,
  cancelButtonClasses: "btn-secondary",
  locale: {
    format: 'LL',
    cancelLabel: 'Abbrechen/Löschen',
    applyLabel: 'Anwenden'
  }
}

var datetimeOptions = {
  showDropdowns: true,
  linkedCalendars: false,
  showCustomRangeLabel: false,
  singleDatePicker: true,
  timePicker: true,
  timePicker24Hour: true,
  opens: "center",
  drops: "auto",
  autoUpdateInput: false,
  cancelButtonClasses: "btn-secondary",
  locale: {
    format: 'LLL',
    cancelLabel: 'Abbrechen/Löschen',
    applyLabel: 'Anwenden'
  }
}

document.addEventListener('initialize', function() {
  $('input.custom_date').daterangepicker(dateOptions)
  $('input.custom_date').each(function() {
    if ($(this).val().length > 0) {
      var moment = require('moment-timezone');
      var newValue = moment($(this).val()).format('LL');

      if (newValue !== "Invalid date") {
        $(this).val()
      }
    }
  })
  $('input.custom_date').on('showCalendar.daterangepicker', function(event, picker) {
    $('.monthselect, .yearselect').select2({ width: '50%', theme: "bootstrap-5", minimumResultsForSearch: Infinity })
  })
  $('input.custom_date').on('apply.daterangepicker', function(event, picker) {
    $(this).val(picker.startDate.format('LL'))

    var hiddenDateInput = $(this).siblings('input')[0]
    $(hiddenDateInput).val(picker.startDate.format('YYYY-MM-DD'))

    if ($(this).hasClass('trigger-filter')) {
      window.submitForm($(this).closest('form'))
    }
  })
  $('input.custom_date').on('cancel.daterangepicker', function(event, picker) {
    $(this).val('')

    var hiddenDateInput = $(this).siblings('input')[0]
    $(hiddenDateInput).val('')

    if ($(this).hasClass('trigger-filter')) {
      window.submitForm($(this).closest('form'))
    }
  })

  $('input.custom_datetime').daterangepicker(datetimeOptions)
  $('input.custom_datetime').each(function() {
    if ($(this).val().length > 0) {
      var moment = require('moment-timezone');
      var newValue = moment($(this).val()).format('LLL');

      if (newValue !== "Invalid date") {
        $(this).val()
      }
    }
  })
  $('input.custom_datetime').on('showCalendar.daterangepicker', function(event, picker) {
    $('.monthselect, .yearselect').select2({ width: '50%', theme: "bootstrap-5", minimumResultsForSearch: Infinity })
  })
  $('input.custom_datetime').on('show.daterangepicker', function(event, picker) {
    if ($(this).val().length == 0 && $(this).data('default-hour')) {
      $('.daterangepicker .hourselect').val($(this).data('default-hour'))
      $('.daterangepicker .hourselect').trigger("change")
    }

    if ($(this).val().length == 0 && $(this).data('default-minute')) {
      $('.daterangepicker .minuteselect').val($(this).data('default-minute'))
      $('.daterangepicker .minuteselect').trigger("change")
    }
  })
  $('input.custom_datetime').on('apply.daterangepicker', function(event, picker) {
    $(this).val(picker.startDate.format('LLL'))

    var hiddenDateInput = $(this).siblings('input')[0]
    $(hiddenDateInput).val(picker.startDate.format('YYYY-MM-DD HH:mm'))

    if ($(this).is(".webinar_appointment_start_time")) {
      var end_time_input = $(this).parents(".row").find("input.webinar_appointment_end_time")
      if (end_time_input.val().length == 0) {
        var date = picker.startDate
        var hours = end_time_input.data('default-hour') - $(this).data('default-hour')
        date.add(hours, 'hours')

        if (end_time_input.data('default-minute')) {
          date.add(end_time_input.data('default-minute'), 'minutes')
        }

        end_time_input.val(date.format('LLL'));
        end_time_input.siblings('input').val(date.format('YYYY-MM-DD HH:mm'))

        var registrationEndDate = picker.startDate
        registrationEndDate.subtract(3, "days")

        $('input.webinar_appointment_registration_end_date').val(registrationEndDate.format('LL'));
        $('input.webinar_appointment_registration_end_date').siblings('input').val(registrationEndDate.format('YYYY-MM-DD'))

        var discountedTill = picker.startDate
        discountedTill.subtract(8, "weeks")
        $('input.webinar_appointment_discounted_till').val(discountedTill.format('LL'));
        $('input.webinar_appointment_discounted_till').siblings('input').val(discountedTill.format('YYYY-MM-DD'))

        initialize()
      }
    } else if ($(this).hasClass("appointment_proposal_start_time")) {
      var endTimeInput = $(this).parents(".card-body").find(".appointment_proposal_end_time")

      if (endTimeInput.val().length === 0) {
        var date = picker.startDate
        var hours = endTimeInput.data('default-hour') - $(this).data('default-hour')
        date.add(hours, 'hours')

        if (end_time_input.data('default-minute')) {
          date.add(end_time_input.data('default-minute'), 'minutes')
        }

        endTimeInput.val(date.format('LLL'));
        endTimeInput.siblings('input').val(date.format('YYYY-MM-DD HH:mm'))
        initialize()
      }
    }
  })
  $('input.custom_datetime').on('cancel.daterangepicker', function(event, picker) {
    $(this).val('')

    var hiddenDateInput = $(this).siblings('input')[0]
    $(hiddenDateInput).val('')
  })

  $('input.daterange').daterangepicker(daterangeOptions)
  $('input.daterange').on('showCalendar.daterangepicker', function(event, picker) {
    $('.monthselect, .yearselect').select2({ width: '50%', theme: "bootstrap-5", minimumResultsForSearch: Infinity })
  })
  $('input.daterange').on('apply.daterangepicker', function(event, picker) {
    $(this).val(picker.startDate.format('L') + ' - ' + picker.endDate.format('L'))

    var startDateInput = $(this).data("startDateInput")
    var endDateInput = $(this).data("endDateInput")

    var names = $(this).attr("name").split("[")
    names.pop()

    var startDateName = names.join("[") + "[" + startDateInput + "]"
    var endDateName = names.join("[") + "[" + endDateInput + "]"
    $("[name='" + startDateName + "']").val(picker.startDate.format('L'))
    $("[name='" + endDateName + "']").val(picker.endDate.format('L'))
  })

  $('input.daterange').on('cancel.daterangepicker', function(event, picker) {
    $(this).val('')

    var startDateInput = $(this).data("startDateInput")
    var endDateInput = $(this).data("endDateInput")

    var names = $(this).attr("name").split("[")
    names.pop()

    var startDateName = names.join("[") + "[" + startDateInput + "]"
    var endDateName = names.join("[") + "[" + endDateInput + "]"

    $("[name='" + startDateName + "']").val('')
    $("[name='" + endDateName + "']").val('')
  })
});

document.addEventListener("turbo:before-cache", function() {
  if ($('input.daterange').length > 0) {
    $('input.daterange').data('daterangepicker').remove()
  }
})